import { useAppDispatch } from 'state/store';
import { updateSelectedBenchmark } from 'state/store/reducers/benchmarkSlice';
import { updateSelectedFunds } from 'state/store/reducers/fundsSlice';
import { updateSelectedValuationDate } from 'state/store/reducers/valuationDatesSlice';

export type UseGenericActions = {
  setSelectedValuationDate: (date: string) => void;
  setSelectedFund: (fund: string) => void;
  setSelectedBenchmark: (benchmark: string) => void;
};

export const useGenericActions = (): UseGenericActions => {
  const dispatch = useAppDispatch();

  return {
    setSelectedValuationDate: (date: string) => {
      dispatch(updateSelectedValuationDate(date));
    },
    setSelectedFund: (fund: string) => {
      dispatch(updateSelectedFunds(fund));
    },
    setSelectedBenchmark: (benchmark: string) => {
      dispatch(updateSelectedBenchmark(benchmark));
    },
  };
};
